import { createAction, handleActions } from 'redux-actions';
import { putSessionStorage } from 'common/CommonFunction';

// 액션 타입 정의
const INIT_USER_STATE = 'common/INIT_USER_STATE';
const INIT_LOGIN_INFO = 'common/INIT_LOGIN_INFO';
const SET_LOGIN_INFO = 'common/SET_LOGIN_INFO';
const SET_USER_ID = 'common/SET_USER_ID';
const SET_USER_NAME = 'common/SET_USER_NAME';
const SET_USER_CODE = 'common/SET_USER_CODE';
const SET_JWT_TOKEN = 'common/SET_JWT_TOKEN';
const INIT_USABLE_MENU = 'common/INIT_USABLE_MENU';
const SET_USABLE_MENU = 'common/SET_USABLE_MENU';
const GET_USABLE_MENU = 'common/GET_USABLE_MENU';

// 액션 생성 함수 정의
export const initUserState = createAction(INIT_USER_STATE);
export const initLoginInfo = createAction(INIT_LOGIN_INFO);
export const setLoginInfo = createAction(SET_LOGIN_INFO, (loginInfo) => loginInfo);
export const setUserId = createAction(SET_USER_ID, (userId) => userId);
export const setUserName = createAction(SET_USER_NAME, (userName) => userName);
export const setUserCode = createAction(SET_USER_CODE, (userCode) => userCode);
export const setJwtToken = createAction(SET_JWT_TOKEN, (jwtToken) => jwtToken);
export const initUsableMenu = createAction(INIT_USABLE_MENU);
export const setUsableMenu = createAction(SET_USABLE_MENU, (usableMenu) => usableMenu);
export const getUsableMenu = createAction(GET_USABLE_MENU);

// 초기상태 init (배포시 값 지울 것)
const initialState = {
  loginInfo: {
    userId: window.sessionStorage.getItem('USER_ID'), // 현재 사용자 ID''
    userName: window.sessionStorage.getItem('PRVC_GNRL_NM'), // 현재 사용자 이름
    userCode: window.sessionStorage.getItem('US_CODE'), // 현재 사용자 코드
    userMUG: window.sessionStorage.getItem('C_US_GRANT_NM'), // 현재 사용자 권한
    jwtToken: window.sessionStorage.getItem('TOKEN'),
    usableMenu: [],
  },
};

const userState = handleActions(
  {
    [INIT_USER_STATE]: (state, action) => ({
      loginInfo: null,
      usableMenu: [],
    }),
    [INIT_LOGIN_INFO]: (state, action) => ({
      loginInfo: null,
    }),
    [INIT_USABLE_MENU]: (state, action) => ({
      usableMenu: [],
    }),
    [SET_LOGIN_INFO]: (state, action) => ({
      ...state,
      loginInfo: {
        userId: action.payload.id, // 현재 사용자 ID
        userName: action.payload.nm, // 현재 사용자 이름
        userCode: action.payload.code, // 현재 사용자 코드
        jwtToken: action.payload.token,
        userMUG: action.payload.grant, //다음 토큰에서 처리
        usableMenu: [],
      },
    }),
    // sample
    [SET_USER_ID]: (state, action) => ({
      ...state,
      loginInfo: {
        userId: action.payload,
      },
    }),
    // sample
    [SET_USER_NAME]: (state, action) => ({
      ...state,
      loginInfo: {
        userName: action.payload,
      },
    }),
    [SET_USER_CODE]: (state, action) => ({
      ...state,
      loginInfo: {
        userCode: action.payload,
      },
    }),
    [SET_JWT_TOKEN]: (state, action) => ({
      ...state,
      loginInfo: {
        jwtToken: action.payload,
      },
    }),
    [SET_USABLE_MENU]: (state, action) => {
      putSessionStorage('MENU_INFO', action.payload);
      return {
        ...state,
        loginInfo: {
          ...state.loginInfo,
          usableMenu: action.payload,
        },
      };
    },
    [GET_USABLE_MENU]: (state, action) => ({
      ...state,
      loginInfo: {
        ...state.loginInfo,
        usableMenu: action.payload,
      },
    }),
  },
  initialState
);

export default userState;
